export class SignInError extends Error {}
export class SignInInitError extends Error {}
export class SignInUserInterruptError extends Error {}

export class InitError extends Error {}

export class ListError extends Error {}
